import { useEffect, useContext } from 'react';
import { getWidth, getTopLeft } from 'ol/extent';
import TileLayer from 'ol/layer/Tile';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import { MapContext } from '../Map';
var WmtsLayer = function WmtsLayer(_ref) {
  var id = _ref.id,
    numberOfZoomResolutions = _ref.numberOfZoomResolutions,
    useBaat = _ref.useBaat,
    opacity = _ref.opacity,
    maxZoom = _ref.maxZoom,
    minZoom = _ref.minZoom,
    zIndex = _ref.zIndex,
    attributions = _ref.attributions,
    uri = _ref.uri,
    layerName = _ref.layerName,
    matrixSet = _ref.matrixSet,
    format = _ref.format,
    layerStyle = _ref.layerStyle,
    crossOrigin = _ref.crossOrigin,
    inputMatrixIds = _ref.matrixIds,
    generateMatrixId = _ref.generateMatrixId,
    onPreRender = _ref.onPreRender,
    onPostRender = _ref.onPostRender;
  var _useContext = useContext(MapContext),
    map = _useContext.map,
    baatToken = _useContext.baatToken,
    getResolution = _useContext.getResolution;
  useEffect(function () {
    if (!map) return;
    var projection = map.getView().getProjection();
    var projectionExtent = projection.getExtent();
    var size = getWidth(projectionExtent) / 256;
    var resolutions = new Array(numberOfZoomResolutions);
    var matrixIds = new Array(numberOfZoomResolutions);
    for (var z = 0; z < numberOfZoomResolutions; ++z) {
      // generate resolutions and matrixIds arrays for this WMTS
      resolutions[z] = size / Math.pow(2, z);
      matrixIds[z] = inputMatrixIds ? inputMatrixIds[z] : generateMatrixId ? generateMatrixId(z) : z.toString();
    }
    var params = {};
    if (useBaat && baatToken) {
      params.GKT = baatToken;
    }
    var tileLoadFunction = function tileLoadFunction(imageTile, src) {
      imageTile.getImage().src = useBaat && baatToken ? src + '&GKT=' + baatToken : src;
    };
    map._layers = map._layers || {};
    var isUrlArray = Array.isArray(uri);
    var layer = map._layers[id] = new TileLayer({
      opacity: opacity,
      minResolution: maxZoom && getResolution(maxZoom),
      maxResolution: minZoom && getResolution(minZoom),
      zIndex: zIndex,
      source: new WMTS({
        attributions: attributions,
        url: isUrlArray ? undefined : uri,
        urls: isUrlArray ? uri : undefined,
        layer: layerName,
        matrixSet: matrixSet,
        projection: projection,
        format: format,
        tileLoadFunction: tileLoadFunction,
        tileGrid: new WMTSTileGrid({
          origin: getTopLeft(projectionExtent),
          resolutions: resolutions,
          matrixIds: matrixIds
        }),
        style: layerStyle,
        crossOrigin: crossOrigin
      })
    });
    if (onPreRender) {
      layer.on('prerender', onPreRender);
    }
    if (onPostRender) {
      layer.on('postrender', onPostRender);
    }
    map.addLayer(layer);
    return function () {
      map.removeLayer(layer);
      delete map._layers[id];
    };
  }, [map, id, attributions, baatToken, crossOrigin, format, getResolution, layerName, layerStyle, matrixSet, maxZoom, minZoom, numberOfZoomResolutions, opacity, uri, useBaat, zIndex, inputMatrixIds, generateMatrixId, onPreRender, onPostRender]);
  return null;
};
export default WmtsLayer;